var map = {
	"./ai-Custom.black.svg": "c0ea8fe4ef4a2e1d7fdd",
	"./ai-Custom.green.svg": "347b5db4d3d14030602a",
	"./ai-Custom.small.svg": "6f94ad1aa182398fbe09",
	"./ai-Custom.white.svg": "f57823e695d2ed141a01",
	"./ai-Exam.green.svg": "f47fdf747f8d9b5f8065",
	"./ai-Exam.light-green.svg": "79d2a3e473b566635e9f",
	"./ai-Exam.small.svg": "3a0b2adb930306aa2a35",
	"./ai-Exam.white.svg": "53fe59155d58b9cd870b",
	"./ai-Glossary.green.svg": "0cf554efd12686710500",
	"./ai-Glossary.light-green.svg": "6b2f62da40d905a4299e",
	"./ai-Glossary.small.svg": "b2006b58907a2a21e501",
	"./ai-Glossary.white.svg": "3745e28327376a0f6800",
	"./ai-Lesson_Hook.green.svg": "810a521bd90558aa1165",
	"./ai-Lesson_Hook.light-green.svg": "23ffe946edafa8dda001",
	"./ai-Lesson_Hook.small.svg": "99b79987fd1e5c5e3fc9",
	"./ai-Lesson_Hook.white.svg": "b8f865b08ea7e75d22b0",
	"./ai-Lesson_Plan.green.svg": "c4c61d0f871ddfa7faee",
	"./ai-Lesson_Plan.light-green.svg": "9deca5f6c6b25cabda26",
	"./ai-Lesson_Plan.small.svg": "fbfcdf85728344e6d1aa",
	"./ai-Lesson_Plan.white.svg": "987bbd43beb2e9dc12c9",
	"./ai-Material.black.svg": "9ef5b47a7b6177e48c69",
	"./ai-Material.green.svg": "737856bbf1c9cc58c8aa",
	"./ai-Material.white.svg": "773f41616a602eeb5f95",
	"./ai-Mixed_Quiz.green.svg": "9d29a89dd9d7c4074c01",
	"./ai-Mixed_Quiz.light-green.svg": "0e897d84011dd96484e0",
	"./ai-Mixed_Quiz.small.svg": "b27e1300cdf782e93cd0",
	"./ai-Mixed_Quiz.white.svg": "cd9b225f5f88ae73523c",
	"./ai-Presentation.green.svg": "238c2e1875c19285f7f6",
	"./ai-Presentation.light-green.svg": "a1a2e6871fa6e43f6c5f",
	"./ai-Presentation.small.svg": "9def3be36c17d502cd52",
	"./ai-Presentation.white.svg": "93eb2b9a1629167bc601",
	"./ai-Quiz.green.svg": "e0d0cfddbd370d4f9586",
	"./ai-Quiz.light-green.svg": "53a73d91cdc0fd966947",
	"./ai-Quiz.small.svg": "d1d3305d0b75a981bbdf",
	"./ai-Quiz.white.svg": "7370f0b6637f29c13aac",
	"./ai-Rubric.green.svg": "ff31ca05f166de4575ec",
	"./ai-Rubric.light-green.svg": "bc262d09754b04c0a530",
	"./ai-Rubric.small.svg": "39fbea2183062b0fa5ba",
	"./ai-Rubric.white.svg": "fec9fe4d5a28b36e8095",
	"./ai-Text_Decoder.green.svg": "5111fb35cfb849004058",
	"./ai-Text_Decoder.light-green.svg": "5978c519e9e39d8f34cd",
	"./ai-Text_Decoder.small.svg": "963c7f903d4bbf1a1a7f",
	"./ai-Text_Decoder.white.svg": "f26fcf833f4626d9f8d4",
	"./ai-Text_Dependent_Questions.green.svg": "a3407cbe11275841c52c",
	"./ai-Text_Dependent_Questions.light-green.svg": "42886933b50e0f0095ac",
	"./ai-Text_Dependent_Questions.small.svg": "b981cfa773c672a7c232",
	"./ai-Text_Dependent_Questions.white.svg": "948738a1ced52a31bd82",
	"./ai-Text_Differentiation.green.svg": "8940f17602c46f5d294f",
	"./ai-Text_Differentiation.light-green.svg": "6111d566576c0b1f01e7",
	"./ai-Text_Differentiation.small.svg": "c2e1fe0fd70108808dc6",
	"./ai-Text_Differentiation.white.svg": "c86206317a007d978de7",
	"./ai-Text_Generator.green.svg": "11b7d518cc395c7cabf0",
	"./ai-Text_Generator.light-green.svg": "127b892a4a37f198347a",
	"./ai-Text_Generator.small.svg": "945e2f7fe33454c32eed",
	"./ai-Text_Generator.white.svg": "dcd65492ae1968ab7971",
	"./ai-Text_Scaffolding.green.svg": "9f6daa96068118cc9af2",
	"./ai-Text_Scaffolding.light-green.svg": "56498a2336952fc5a94d",
	"./ai-Text_Scaffolding.small.svg": "513c9525e04dcf901ec7",
	"./ai-Text_Scaffolding.white.svg": "4eab4e8977de400493d8",
	"./ai-Unit_Planner.green.svg": "1de0f48ba8161be6fd94",
	"./ai-Unit_Planner.light-green.svg": "aa8a8f98a069b468dcbe",
	"./ai-Unit_Planner.small.svg": "465edacb1c22d97840a4",
	"./ai-Unit_Planner.white.svg": "eca249537b49dae32e00",
	"./ai-Website.black.svg": "2d3038db4a39c81c8389",
	"./ai-Website.green.svg": "a53d2e654452403b4f3e",
	"./ai-Website.white.svg": "f1a35bf264ff6896f288",
	"./ai-Worksheet.green.svg": "d979208b9b4ab36dc13c",
	"./ai-Worksheet.light-green.svg": "d444b24061fb002d14f5",
	"./ai-Worksheet.small.svg": "fb63dd60ce5d718fc5ee",
	"./ai-Worksheet.white.svg": "eb3a650796641c9599d9",
	"./ai-Youtube.black.svg": "98914b9af4ec4da632ee",
	"./ai-Youtube.green.svg": "bec923312f12706aee33",
	"./ai-Youtube.white.svg": "aaeb77b7eaf8a75ca71c",
	"./ai-check-circle.svg": "c849f278f134451dc68e",
	"./ai-error.svg": "2a9ff73cf75d3fbf695d",
	"./ai-info.svg": "fc804ba86f5aa1720f92",
	"./ai-star-regular.svg": "2d08d978740c92c6083a",
	"./ai-stars-header.svg": "f985f9ac373472490817",
	"./ai-stars-outline.dark-green.svg": "372fded2d7f05fe6cb56",
	"./ai-stars-outline.gray.svg": "086174bfbd5cbdfe8af2",
	"./ai-stars-outline.light-green.svg": "56d45a5816370da890af",
	"./ai-stars.black.svg": "bcb9fe5a784186030997",
	"./ai-stars.green.svg": "efeee50a869eea148163",
	"./ai-stars.svg": "47af8d94a880f8e57d96",
	"./ai-stars.white.svg": "5585ad34d36d33d03410",
	"./ai-tool-default.black.svg": "036d0d13fc9f8dc87672",
	"./ai-tool-default.green.svg": "36c35686f6b8db77d634",
	"./ai-tool-default.light-green.svg": "5da2095c061ed28c8f95",
	"./ai-tool-default.small.svg": "c7c907d40e219b029d68",
	"./ai-tool-default.white.svg": "a8be61d5be1c937d8c23",
	"./angle-down-new.svg": "7d2a389c4a4e8e1801de",
	"./angle-down.red.svg": "0c5bb4265438538c812b",
	"./angle-down.svg": "cedc329b72f11c2b01ff",
	"./angle-left-new.svg": "40c977db7959c83fedef",
	"./angle-left.svg": "cbadf5571d516ef2fda0",
	"./angle-right.red.svg": "90dfae5f17384f86ab26",
	"./angle-right.svg": "c0af6f5d18f805c1bc0d",
	"./angle-thin-down.svg": "f650c59cdc1756a76868",
	"./angle-thin-left.svg": "ea5ddedaa9749c8f8859",
	"./angle-thin-right.gray.svg": "66f24459881c11ef8218",
	"./angle-thin-right.svg": "2131b5d8f7da50b2a6da",
	"./angle-up.svg": "abab72a33fde86281cb6",
	"./apple.black.svg": "171eefccf4b0d12cf658",
	"./apple.white.svg": "48cabc6d7e4e4e369c23",
	"./arrow-down-24.svg": "b46035547942081165d6",
	"./arrow-left.gray.svg": "f8dcf0a98383af1be3be",
	"./arrow-left.svg": "b7e213dc8d4e302fcb32",
	"./arrow-right.big-black.svg": "ae19307643bcb83bb272",
	"./arrow-right.black.svg": "d24360f9096b0a3a3441",
	"./arrow-right.gray.svg": "03080d2701699c7b4635",
	"./arrow-right.green.svg": "c1b60ccf38a3074cf0db",
	"./arrow-right.svg": "fa3dae488c887db178b1",
	"./arrow-right.white.svg": "44056b22dbe455d4af38",
	"./arrow-up-white.svg": "e9d58f860958c0864f57",
	"./arrow-up.svg": "b155d16cd8209321998a",
	"./article.svg": "059033f4fdebdde6167b",
	"./auto_fix.svg": "6ded68dbf56e1f1c326d",
	"./avatar.svg": "16176dbaa12233bdb1e6",
	"./book.black.svg": "17c554629199fed5bb0b",
	"./book.grey.svg": "844c3362bc87694318ad",
	"./book.svg": "73ea6ecb5a67a9962528",
	"./box.blue.svg": "b0a59223f1260adf8f85",
	"./box.white.svg": "c9f26474be3573d61f15",
	"./bulb.green.svg": "512b2515f646a4cb8bae",
	"./bulb.light-green.svg": "a03ed8930ba99f75d59c",
	"./camera-transparent.svg": "b9a88990fae54cd3939c",
	"./camera.svg": "536a5ebfb9a657b36021",
	"./cancel.red.svg": "5dc91ed31b0d4f5c05eb",
	"./cancel.svg": "54f52a435b9e4efba8ed",
	"./category.grey.svg": "197034097fb27c00aed2",
	"./certified-check.svg": "d7bd5f2253662ef74acf",
	"./certified-green.svg": "910a969ffb9af7e2e5b8",
	"./certified.svg": "44a4b3d13a0fee7cfcd8",
	"./chart-line.svg": "010c32a9bc2b38c95636",
	"./chart.svg": "8180d655423440d448ee",
	"./check-circle-dark-green.svg": "882e252bb4f2384f6dc9",
	"./check-circle-empty-green.svg": "12bbff30ea1effaad137",
	"./check-circle.black.svg": "1cc75cb975fa5df7745f",
	"./check-circle.green-ci.svg": "7ed4b4b1ae0df8b014de",
	"./check-circle.green.svg": "80c6e7b9a677ad1c8f2d",
	"./check-circle.svg": "3efe134ca486b2a21bca",
	"./check-circle.turquoise.svg": "58a771ed0bafd57404ab",
	"./check-list.svg": "596eaa26279d0f941d65",
	"./check-md.green.svg": "6553d1a8732c153ada7c",
	"./check-thin.svg": "10a99fc03bb44950fb64",
	"./check-thin.white.svg": "5d50d1fce34a3ccf27ec",
	"./check.black.svg": "31a6455b62b274049ed9",
	"./check.green.svg": "6cb0837ed1cbd32ba5df",
	"./check.grey.svg": "294533600b463064c27e",
	"./check.navy.svg": "0ada7f3cb0ff6dbe98c8",
	"./check.svg": "6bdcd6a5a1bc70a399c0",
	"./check.white.svg": "135bd747e77de8ad432c",
	"./check_circle.svg": "76f003ec021bf1b36da9",
	"./check_circle.white.svg": "c88e5190d3b3bf46a3dd",
	"./checkmark-circle.green.svg": "41152d13de6897c42a95",
	"./chevron-down.svg": "d915a6a1f6e7f1a4cc57",
	"./chevron-down.white.svg": "e17b303f2529e432f281",
	"./chevron-left.black.svg": "57f556d9cdf3937cfb43",
	"./chevron-right.black.svg": "3057c40fddf007ff7f78",
	"./chevron-right.svg": "958c54fec379cd54dbc8",
	"./circle-cancel.red.svg": "bec933f9fc4a00a1bd74",
	"./circle-chevron-down.red.svg": "92acaebfea5b8abcebf5",
	"./circle-chevron-down.svg": "55f81d047f1310f650ff",
	"./circle-outline.gray.svg": "d119ec11952e6479cf5f",
	"./clock-regular.svg": "c781abe0925ec657d4f8",
	"./clock.svg": "5bc6dc72ff2b024efbed",
	"./clone.svg": "7b651edbe3053a2716d0",
	"./close.black.svg": "92146bda2c445fde7108",
	"./close.red.svg": "23f223f4582389351fcf",
	"./close.svg": "0e0dacff52e466a4cfb1",
	"./close.white.svg": "d3b489efd7353c1a18de",
	"./cloud.green.svg": "20a68814874b5cb2e0a2",
	"./comments.grey.svg": "a115bc5d8eff1f3234a6",
	"./comments.svg": "0bb208c81853ab5ed961",
	"./content_copy.svg": "eba6e71479e0a9f1cb2b",
	"./copy-24.svg": "34f57e9dac23a18e4bdf",
	"./copy.svg": "7ad48db14e7fcd299ea6",
	"./delete.black.svg": "294ef9d2166f2e49ce7d",
	"./delete.blue.svg": "869dcd66669a0a559233",
	"./delete.gray.svg": "d35e058c129c3a3d092d",
	"./delete.green.svg": "aececc4a4ff392f85318",
	"./delete.red.svg": "e37faf461a3df6315c82",
	"./delete.svg": "98e54f71b61bf3a5b06e",
	"./design_services.svg": "e0031c8fe3179a8fa74c",
	"./document-pencil.svg": "4585dbb1766b84cae8fd",
	"./document-text.svg": "e61ef692b0aa704c7645",
	"./document.svg": "958b45ec6c13aff6bf76",
	"./dots.svg": "a9a9edc128e2f4447934",
	"./download-transparent.svg": "c4ff08942cce426e180d",
	"./download.svg": "4070aaf5217a71e5522f",
	"./download.white.svg": "4f2c04dd2eb665cd8025",
	"./edit-24.svg": "db72c2497dfc06ed8810",
	"./editor-add-column-left.svg": "085e653b8fda2e373fd1",
	"./editor-add-column-right.svg": "18e6e3096988f5d89de6",
	"./editor-add-row-above.svg": "5ddacde775c5147c3b94",
	"./editor-add-row-below.svg": "e51f098f4f4b2f4573c2",
	"./editor-block-code.svg": "147c81ca31b0a9d52fbf",
	"./editor-bold.svg": "69f708ded84b22990fcd",
	"./editor-brush.svg": "723a527bc5e6894cba46",
	"./editor-code.svg": "0453f56543c60b210644",
	"./editor-column-left.svg": "965998a15d22ce018b67",
	"./editor-delete-column.svg": "f71d132a200497853d32",
	"./editor-delete-row.svg": "4b9246373319ce5ee5b0",
	"./editor-formula.svg": "bc5e6347174653ad3bba",
	"./editor-horizontal.svg": "1ce277c82fc60073b074",
	"./editor-italic.svg": "60aebf26b8c26160e01a",
	"./editor-link.svg": "5bc6a9c2783c55e49b88",
	"./editor-list-bulleted.svg": "04601c9253f950f7dcee",
	"./editor-list-dot.svg": "a13043f9469965bdcb21",
	"./editor-list-numbered.svg": "fbbeded6a0912c855a79",
	"./editor-quote.svg": "cfa5fba9de30327c8a8a",
	"./editor-redo.svg": "4add33e3b314a78c69bd",
	"./editor-table-delete.svg": "50d0ae4414de55d22219",
	"./editor-table.svg": "66cab418b0f0a15e99b2",
	"./editor-text-bg-color.svg": "48fa9eafb0af5f7b945a",
	"./editor-text-center.svg": "99b09d6c44dd9911be3c",
	"./editor-text-clean.svg": "f03df0bc005a584d4613",
	"./editor-text-color.svg": "b95f19cd7dc2fa7938d3",
	"./editor-text-justify.svg": "fb7fb405443f96594095",
	"./editor-text-left.svg": "381b5a5a227f485d1533",
	"./editor-text-palette.svg": "abd2e0e15e67143bbd61",
	"./editor-text-right.svg": "fa8f459424cc39f86141",
	"./editor-underlined.svg": "f308a81639e23483b240",
	"./editor-undo.svg": "dd6e7abc30619163d826",
	"./euro.sky.svg": "92499ad74bdb2a19240e",
	"./exclamation-triangle.brown.svg": "04e63677fbf0440f976b",
	"./expand-more.grey.svg": "3b07c386a9fec81fa598",
	"./expand-more.svg": "4b422113c4de82ca899d",
	"./explore.blue.svg": "67c656887a800c280e28",
	"./explore.white.svg": "e7a8d3fe7245dd5f7be8",
	"./eye-slash.black.svg": "40f29b1b4aae15e4a1c6",
	"./eye-slash.grey.svg": "6b6160a61bf93f9e2332",
	"./eye-slash.svg": "b93e5d26cdeeb9787fa2",
	"./eye.black.svg": "5af8e6368fee706c85c8",
	"./eye.grey.svg": "41c16eba05f2c669d4f6",
	"./eye.lightgrey.svg": "48adc92bf9f8238ffe8a",
	"./eye.svg": "dc12ea8676fa2bf13a57",
	"./facebook-black.svg": "020d92de3e129b509313",
	"./facebook-f.blue.svg": "95c1c81cbdc4cd92c35c",
	"./facebook-f.svg": "f1698794b2692293b6ac",
	"./facebook-f.white.svg": "11dfe365717e7617b9f1",
	"./facebook.svg": "b65c7933983e6ef1f608",
	"./facebook_logo.svg": "e09e753edac29e23bb86",
	"./favorite.green.svg": "6dda0bf1a02559273e46",
	"./favorite.svg": "0bb6ebc6832f0c7c06ce",
	"./file.green.svg": "fe7721f822675b1f2c5f",
	"./file.svg": "bb9d8392f53bf93bcd40",
	"./finger-interactive.svg": "8744363805e8ba891eea",
	"./followers.small.svg": "642b4b3ce80cba14a4d4",
	"./followers.svg": "dd029461e3d36af4c6a9",
	"./following.small.svg": "c313cc8fd49c3e87831b",
	"./following.svg": "407422400fceac88934b",
	"./forum.svg": "c80b0f47dbfa0e91050f",
	"./globe.svg": "47464b4fc146fff7d1b1",
	"./grade.green.svg": "9ac35589f7144b353aa3",
	"./grid-icon.black.svg": "b578269f69e7426c2293",
	"./grid-icon.blue.svg": "f245cb9e273014dc2b13",
	"./grid-icon.lightgrey.svg": "9332849673ac637e20ec",
	"./group.black.svg": "7ebe0fff90ced56a9e1f",
	"./group.blue.svg": "2c9f7dc0e386c97e7c0d",
	"./groups2.blue.svg": "04a98a5f21eeaee66bf4",
	"./groups2.white.svg": "abcb7a453a9326ab881f",
	"./heart-regular.blue.svg": "9da47b7539fb0d3e843b",
	"./heart-regular.svg": "b1801b47a79790f01443",
	"./heart.blue.svg": "80418c01d2a7969b0003",
	"./heart.grey.svg": "9b5c8360d49ec9d72e98",
	"./heart.svg": "fa44c522d35e821d80de",
	"./help.svg": "55b9b9ff3e8d178df3a3",
	"./history.svg": "710133ce03bac15167c6",
	"./home.blue.svg": "223afdcc01233098faaf",
	"./home.white.svg": "6c0a54f7e037b3f806aa",
	"./image-2.svg": "f1e46ed769bc2c99817e",
	"./image.svg": "191aa4a2a828e5b9eb72",
	"./info-circle.svg": "6add92153d14cd5ffd3e",
	"./info-circle.teal.svg": "85eccf561fefdba50ec0",
	"./info-exclamation.svg": "a88b7ad44ad22d551a3a",
	"./info-filled.teal.svg": "53c2fc23e6d3892fd6be",
	"./info.dark-green.svg": "c744b4b956cea99e6b30",
	"./info.green.svg": "31863d9b876a637d3581",
	"./info.svg": "c040f20ecf4a03d21a4a",
	"./info.white.svg": "a2fed7e76f29c3e9fa1b",
	"./info.yellow.svg": "972e9d8d7b580565162c",
	"./instagram-black.svg": "f0b81cfcb143c8fe6381",
	"./instagram.svg": "73e41638a859c23c6b80",
	"./interactive-finger.yellow.svg": "00eb94bda944d3f3e495",
	"./interactive-full.cyan.svg": "a973e3fa870b9fa3fb44",
	"./interactive-full.gray.svg": "4d70bac35cf670dc2feb",
	"./interactive-logo-compact.white.svg": "377f3bf916f2202235a0",
	"./interactive-logo.purple.svg": "9033f4bcdc3a5c429239",
	"./interactive-logo.white.svg": "25ce1e41091c99fb751c",
	"./ios_share.svg": "5c9907f8a64e41ada0fb",
	"./key.svg": "9a9de8294c778f02f535",
	"./key.white.svg": "fdd9c986a49bca648617",
	"./lesson-plan.svg": "c6c008dad80afcfb7dbb",
	"./lesson-plan.white.svg": "dda0c6b485987ddcba02",
	"./level-up-alt.lightgrey.svg": "1fcdf01d0746184cbbb4",
	"./level-up-alt.svg": "01be957a2fc6c92b535f",
	"./like.sky.svg": "9daf803d38dae4983100",
	"./like.svg": "d89b12e917356cbd7035",
	"./link.black.svg": "1529dc40acf6235671c3",
	"./list.blue.svg": "078abce43bd47c5c52c9",
	"./list.lightgrey.svg": "dacda1207853080b179e",
	"./list.svg": "3f6a43083c0939955f78",
	"./local_offer_black_24dp.svg": "1baf8cfc3f207db95a1d",
	"./lock.svg": "64be788c15c3f0eaebf5",
	"./logo-with-stars.svg": "675011b522df7f64557b",
	"./long-arrow-alt-down.lightgrey.svg": "b198b8ca0f32fd7a19e5",
	"./long-arrow-alt-down.svg": "ce81439e04c53ec4144d",
	"./long-arrow-alt-up.lightgrey.svg": "11f398627eaa92a411f2",
	"./long-arrow-alt-up.svg": "50e659260bbf384d2d4b",
	"./magic-wand.svg": "ebfcdc091e30143437e0",
	"./magic-wand.white.svg": "7dafe6e8079b410df24c",
	"./mail.svg": "47ecf94c7e7125dc296c",
	"./material-download.svg": "4308688bab43c0d9b41f",
	"./minus.black.svg": "be5acca628214aeb81a1",
	"./minus.gray.svg": "e8a2ec72e2627d0673d2",
	"./minus.green.svg": "6a76395ac206a781ebbf",
	"./minus.svg": "a44b29c0fc6d514b197b",
	"./more_horiz.svg": "326250d293c0955e793a",
	"./note.small.svg": "7572437e8fccd3321854",
	"./note.svg": "0d0ac9034c42ef1174a2",
	"./noun-comment.svg": "b9a827aced28d256a52a",
	"./noun-like.svg": "7a896f9ab89ebf98f4c3",
	"./open-in.svg": "c2f08de5d0ff3148eb18",
	"./palette.grey.svg": "3ba06ffd1fbe55b88d47",
	"./pause.lightgrey.svg": "eeb5b9c23005522d4644",
	"./pause.svg": "dca1f481d96d04ea8231",
	"./payments.svg": "dfa4dbdda43888bbd20e",
	"./pencil-alt.svg": "54ff970918820c272511",
	"./pencil-transparent.black.svg": "cdf55d3069e49d156d81",
	"./pencil-transparent.grey.svg": "f85d4c1d5d8c66497b8e",
	"./pencil-transparent.svg": "5c623b0eeb842e8c7747",
	"./percent.green.svg": "583115bd680809d176e0",
	"./percent.purple.svg": "cdb15b1e8725c45a185f",
	"./percent.red.svg": "33f613f51a6f5a38ac47",
	"./percent.svg": "e5dfe7bc55a9de89375f",
	"./pinterest-black.svg": "adff5d42acf6e3578ff9",
	"./pinterest.svg": "5c235b50d5931bbc6597",
	"./play.lightgrey.svg": "e5764b7d7a81941b283a",
	"./play.svg": "9bfa055fe990b52db32b",
	"./play_arrow.svg": "68943920ae2563523155",
	"./plus.black.svg": "57b4eb098b5f5a262ee4",
	"./plus.cyan.svg": "c69e2409d857f77befa7",
	"./plus.gray.svg": "dbf555a770810fc57363",
	"./plus.green.svg": "8c8a9d83d2bbae3dae30",
	"./plus.svg": "337367ac689330c6b2c9",
	"./plus.white.svg": "a4bd118b38a173d5f308",
	"./print.svg": "b742800159316d2cba52",
	"./publish-24.svg": "5c329d2d45ddcfd44e9c",
	"./publish.svg": "3718dff837a94df5c1fa",
	"./pupils.blue.svg": "bd666c57e5d9390489f4",
	"./puzzle.svg": "3ad7c6f1668aae69121f",
	"./qr.black.svg": "2c766e1bdc8b563cc76e",
	"./question-circle.green.svg": "ede3b32f7530d64f0010",
	"./question-circle.svg": "d2bfb1aa878d23baaa53",
	"./quiz.black.svg": "f2fb6e3c962415748f9e",
	"./quiz.svg": "07930af5c02a955e5dc0",
	"./quiz.white.svg": "e5f1b66db888c825f0bf",
	"./rating.svg": "e88490f8ad70fdc591ae",
	"./refresh.svg": "5e5e48bff29395a470f8",
	"./reply.svg": "f12881ad84ca6ceace65",
	"./sale.svg": "28c83369f941df24c859",
	"./save-24.svg": "f0d4071faa259f6855b2",
	"./save.svg": "f9425bb08ca512000044",
	"./savings.svg": "ccbcdc5df6605cb98881",
	"./schedule-clock.svg": "0d56f989d307e82c0068",
	"./school-white.svg": "43c57668a99461b566fb",
	"./school.grey.svg": "8ef741f9e09ee7a6ff97",
	"./school.svg": "4f9483e0cfdf498be63f",
	"./school.white.svg": "3a48d48e525d9f2a3f2f",
	"./search.black.svg": "30eda5d947806634f783",
	"./search.svg": "de060bd2c4f4ef477512",
	"./search.thin.svg": "a7213b9b6287e4ec6ddd",
	"./search.white.svg": "e1a11a76bfdf7394380d",
	"./settings.svg": "9dee0a9d9c5c07c49842",
	"./share-24.svg": "156b923409ebd076ec9f",
	"./share-white.svg": "66e6c0ad2451304f1e7e",
	"./share.svg": "9d311f463031aa6e335c",
	"./sounder.svg": "ab097d705ca6f429c797",
	"./star-regular.svg": "f8c890dabf828239479a",
	"./star.orange.svg": "106c7a4d35fc52e4c03a",
	"./star.svg": "1a73f479efb32fbd1a77",
	"./task.blue.svg": "18dedaaaddd1c47ee7c2",
	"./task.white.svg": "07a3a4850a338b00c3e6",
	"./thumbs-up-regular.svg": "bfa6fd640c55e71ac626",
	"./times-ci.svg": "621a3d005581b76aba93",
	"./times-circle-regular.pink.svg": "5a5f890fdf34744918db",
	"./times-circle.svg": "4ad866cbab407129398e",
	"./times-red.svg": "6f24e1d396c4631e0d59",
	"./times.lightgrey.svg": "aa108a14bdfc439d3095",
	"./times.red.svg": "7cdb4704330c913d9da1",
	"./times.svg": "b4548ac531e599b2a082",
	"./times.white.svg": "4b17c133480c4225a24d",
	"./tool-key.svg": "bede90b3091fb267b0cc",
	"./tool-quiz.svg": "3927ac285029fb98a0b0",
	"./translate.grey.svg": "c171bee773598ef7e540",
	"./tune.blue.svg": "eafff45f20824e635e06",
	"./tune.svg": "76d65ab00239f82bb677",
	"./twitter.svg": "b607cba5bbfecb449072",
	"./unlock.svg": "8dc9c0996cee5a5c5ba3",
	"./vector.svg": "bb771018ef935f14106d",
	"./verified-author.svg": "64f9f1882d32fa5df006",
	"./video.svg": "dda906a74abd4ea9ab91",
	"./voucher.svg": "61254779b27d79e64f01",
	"./warn.gray.svg": "d606c96ea733ae933ab2",
	"./warn.yellow.filled.svg": "1faa9e919b866f7d90db",
	"./warn.yellow.svg": "b5122a206dc29f377658",
	"./warning-triangle.red.svg": "8a50dc7697c241b29800",
	"./warning-triangle.yellow.svg": "c3d141eef5eca641c5a1",
	"./workspace-premium.green.svg": "d49b3c7ccb2086d62f4b",
	"./workspace-premium.grey.svg": "d2d1556fcee89c809af4",
	"./workspace-premium.svg": "3e32068e599a54c082f6",
	"./youtube.svg": "104f84480f84bd897f59",
	"./zoom-in.svg": "73a50c8a9da89e717b52",
	"./zoom.svg": "8103277a28cd73c8d042"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08a5cd5fb2f70c359759";